import templateUrl from "servicestack/page-sizes.htm";

export default {
  bindings: {
    db: "<ngModel",
    dropup: "@",
    size: "@",
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
